import { html } from "lit-element";
import "@material/mwc-button";
import { StatefulModule } from "../../ModuleBase/ModuleMetadata";

export class DrawSamplePumpModule extends StatefulModule {
	Activate() {
		this.canvas.defaultCursor = "crosshair";
		this.__onDraw = this.onDraw.bind(this); //save reference to bound function to be able to deactivate
		this.canvas.on("mouse:down", this.__onDraw);
		return this;
	}

	Deactivate() {
		this.canvas.setCursor(this.canvas.defaultCursor);
		this.canvas.off("mouse:down", this.__onDraw);
	}

	onDraw(o) {
		this.Draw(this.canvas.getPointer(o.e));
		this.fireOnDraw();
	}

	static MakeGroup(pointer, label, fillColor, fontColor, size = 20) {
		let circle = new fabric.Circle({
			radius: size,
			fill: fillColor,
			stroke: "#000",
			strokeWidth: 2,
			originX: "center",
			originY: "center"
		});

		let text = new fabric.Text(label, {
			fontSize: size,
			fontFamily: "Arial",
			originX: "center",
			originY: "center",
			fill: fontColor,
			fontWeight: "600"
		});

		let group = new fabric.Group([circle, text], {
			top: pointer.y,
			left: pointer.x,
			hasBorders: true,
			hasControls: false,
			originX: 0,
			originY: 0,
			selectable: false
		});

		return group;
	}

	Draw(
		pointer,
		label = this.text,
		fillColor = this.fillColor,
		fontColor = this.fontColor
	) {
		let group = DrawSamplePumpModule.MakeGroup(
			pointer,
			label,
			fillColor,
			fontColor
		);
		this.addMetadata(group, {
			fillColor: fillColor,
			fontColor: fontColor,
			text: label
		});

		this.canvas.add(group);
		this.canvas.renderAll();
	}

	RenderSettings(obj, closeFunc) {
		const currentSettings = obj.moduleState;
		let tempNumber = currentSettings.text;

		const applyFunc = () => {
			this.applyNewSettings(obj, tempNumber);
			closeFunc();
		};

		return html`
            <style>
                .title {
                    font-size: x-large;    
                    font-weight: bold;
                    margin-bottom: 20px;
                }
                .button-box {
                    display: flex;
                    margin-top: 20px;
                }
            </style>

            <div class="title">Sample or pump settings</div>    
            <div> 
                <text-box type="text" label="Number" 
                    @change="${e => (tempNumber = e.currentTarget.value)}"
                    .value="${currentSettings.text}"></text-box>
            </div>
            <div class="button-box">
                <mwc-button @click="${closeFunc}" label="Close"></mwc-button>
                <mwc-button @click="${applyFunc}" label="Apply"></mwc-button>
            </div>`;
	}

	applyNewSettings(group, text) {
		const currentSettings = group.moduleState;
		if (currentSettings.text == text) return;

		this.addMetadata(group, { text: text });
		group.item(1).set({ text: text });
		this.canvas.renderAll();
		this.canvas.trigger("object:modified", { target: group });
	}

	render() {
		return html`
            <style>
                :host {
                    position: relative;
                    display: block;
                    padding: 7px;
                    background-color: inherit;
                }

                label {
                    display: block;
                    font-weight: 600;
                    cursor: pointer;
                    border-radius: 50%;
                    width: 25px;
                    height: 25px;
                    align-content: center;
                    text-align: center;
                    line-height: 28px;
                }

                label div {
                    border: solid 1px black;
                    border-radius: 25px;
                    height: 25px;
                    width: 25px;
                    text-align: center;
                }
            </style>

            <label style="background-color: ${this.fillColor}; color: ${this.fontColor};">
                ${this.text}
            </label>`;
	}

	static get properties() {
		return {
			fillColor: String,
			fontColor: String
		};
	}

	constructor(canvas, fillColor, fontColor, text = "X") {
		super();
		this.text = text;
		this.fillColor = fillColor;
		this.fontColor = fontColor;
		this.canvas = canvas;
	}
}

window.customElements.define("inspx-draw-sample-pump", DrawSamplePumpModule);
